import { RootState } from "../../reducers";

export const alertMessageSelector = (state: RootState): string =>
  state.alert.message;
